import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { Box, Typography, CircularProgress, Paper } from '@mui/material';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import analyticsService from '../services/analyticsService';

// Registrar los componentes necesarios de Chart.js
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const ClientsByDayChart = ({ filters }) => {
  const [loading, setLoading] = useState(true);
  const [clientsData, setClientsData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await analyticsService.getClientsByDay(filters);
        // Ordenar los datos por día de la semana (1-7)
        const sortedData = data.sort((a, b) => a.day_of_week - b.day_of_week);
        setClientsData(sortedData);
        setError(null);
      } catch (err) {
        console.error('Error al obtener datos de clientes por día:', err);
        setError('No se pudieron cargar los datos de clientes por día');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [filters]);

  const chartData = {
    labels: clientsData.map(item => item.day_name),
    datasets: [
      {
        label: 'Promedio de clientes por día',
        data: clientsData.map(item => item.average_clients),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        tension: 0.1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Afluencia de Clientes por Día de la Semana',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Promedio de Clientes'
        }
      }
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" gutterBottom>
        Afluencia de Clientes por Día
      </Typography>
      <Box sx={{ height: 400, position: 'relative' }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Typography color="error">{error}</Typography>
          </Box>
        ) : clientsData.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Typography>No hay datos disponibles para el período seleccionado</Typography>
          </Box>
        ) : (
          <Line data={chartData} options={options} />
        )}
      </Box>
    </Paper>
  );
};

export default ClientsByDayChart;
